'use strict';

var trackingUtils = require('../modules/utils/tracking.utils');

var getClusterPolicy = function(selected) {
    return selected ? 'CANXSELF' : 'none';
};

var getPolicyIdentifier = function(selected) {
    return selected ? 'CANXSELF' : 'standard';
};
module.exports = {
    trackOnClickSelectFairUpgradePanel: function(data) {
        trackingUtils.trackEvent(data.action, [
            'open_result_clus:',
            getClusterPolicy(data.shown),
            '-pol:',
            getPolicyIdentifier(data.shown),
        ].join(''));
    },
    trackOnSubmitFairUpgradeSelection: function(data) {
        trackingUtils.trackEvent(data.action, [
            'select_result_clus:',
            getClusterPolicy(data.selected),
            '-pol:',
            getPolicyIdentifier(data.selected),
        ].join(''));
    },
    trackOnClickFareUpgradeTermsAndConditions: function(data) {
        trackingUtils.trackEvent(data.action, [
            'open_info_clus:',
            getClusterPolicy(true),
            '-pol:',
            getPolicyIdentifier(true),
        ].join(''));
    },
};
